module.exports = __webpack_public_path__ + "video-player.svg?861ce2d761c952dbcf0f23ea82a41f61";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video-player.svg
// module id = 331
// module chunks = 2